import { Route } from '@angular/router';
import { smartDeviceRoutes } from 'src/app/modules/smart-devices/smart-devices.routes';

import { venueLocalGameRoutes } from '../../modules/local-games/local-games.routes';
import { DC_ROUTING } from '../../shared/routing.tokens';

export const venuesRoutes: Route[] = [
    {
        path: DC_ROUTING.DASHBOARD_VENUE,
        loadComponent: () =>
            import('../../modules/dashboard/pages/dashboard-venue/dashboard-venue.component').then(
                (c) => c.DashboardVenueComponent
            ),
    },
    {
        path: DC_ROUTING.VENUE_SETTINGS,
        loadComponent: () =>
            import('../../modules/account-settings/pages/venue-settings-menu/venue-settings-menu.component').then(
                (c) => c.VenueSettingsMenuComponentComponent
            ),
    },
    {
        path: DC_ROUTING.APP_SETTINGS,
        loadComponent: () =>
            import('../../modules/account-settings/pages/app-settings/app-settings.component').then(
                (c) => c.AppSettingsComponent
            ),
    },
    {
        path: DC_ROUTING.GAME_SETTINGS,
        loadComponent: () =>
            import('../../modules/account-settings/pages/game-settings/game-settings.component').then(
                (c) => c.GameSettingsComponent
            ),
    },
    {
        path: DC_ROUTING.SMART_DEVICE_SETTINGS,
        loadComponent: () =>
            import('../../modules/smart-devices-settings/pages/smart-devices-settings/smart-devices-settings.component').then(
                (c) => c.SmartDevicesSettingsComponent
            ),
    },
    {
        path: DC_ROUTING.ACCOUNT_SETTINGS,
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('../../modules/account-settings/pages/account-settings/account-settings.component').then(
                (c) => c.AccountSettingsComponent
            ),
    },
    {
        path: DC_ROUTING.LOCAL_PRACTICE_GAMES,
        loadComponent: () =>
            import('../../modules/local-games/pages/venue-local-games/venue-local-practice-games.component').then(
                (c) => c.VenueLocalPracticeGamesComponent
            ),
    },
    {
        path: DC_ROUTING.PARTY_GAMES,
        loadComponent: () =>
            import('../../modules/local-games/pages/party-games/party-games.component').then(
                (c) => c.PartyGamesComponent
            ),
    },
    {
        path: DC_ROUTING.LOCAL_VENUE_PARTY_GAMES,
        loadComponent: () =>
            import('../../modules/local-games/pages/venue-local-target-arcade-games/venue-local-target-arcade-games.component').then(
                (c) => c.VenueLocalTargetArcadeGamesComponent
            ),
    },
    {
        path: DC_ROUTING.PRE_GAME,
        data: {
            hideTournamentNotification: true,
        },
        loadComponent: () =>
            import('../../modules/games/pages/pre-game/pre-game.component').then((c) => c.PreGameComponent),
    },
    ...venueLocalGameRoutes,
    ...smartDeviceRoutes,
    { path: '**', redirectTo: DC_ROUTING.DASHBOARD_VENUE },
];
